<template>
  <div
    v-if="data?.title"
    :class="$style.root"
  >
    <div
      v-if="category || year"
      :class="$style.category"
    >
      {{ [category, year]?.filter(Boolean).join(', ') }}
    </div>

    <h1
      :class="$style.heading"
      v-html="data?.title"
    />

    <slot />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object
  },
  category: {
    type: String,
    required: false
  }
})

const year = new Date(props?.data?.datePublished)?.getFullYear()
</script>

<style module lang="scss">
.root {
  // @media (min-width: $breakpoint-s) {
  //   padding-left: calc(var(--size--button) + var(--unit--horizontal));
  // }
}

.heading {
  composes: font-size-large from global;
  composes: reset-heading from global;
}

.category {
  color: var(--color--secondary);
}
</style>
